import React from 'react';
// graphql
import gql from 'graphql-tag';
// global variables
import { localStorageAuthKey as AUTH_TOKEN } from 'config';
// our components
import { DASHBOARD } from 'routes/paths';
import RouterContext from 'helpers/routerContext';
import AuthContext from 'helpers/authContext';
import { Mutation } from 'components/common/Query';
import ChangePassword from './ChangePassword';

/**
 * Mutation to update user
 */
export const UPDATE_USER_MUTATION = gql`
  mutation($id: ID, $password1: String, $password2: String) {
    updateAdminUser(
      input: { id: $id, password1: $password1, password2: $password2 }
    ) {
      token
      errors {
        field
        messages
      }
      clientMutationId
    }
  }
`;

/**
 * @class
 * @extends React.Component
 */
class UserChangePasswordContainer extends React.Component {
  static contextType = RouterContext;

  constructor(props) {
    super(props);
    this.state = {
      errors: [],
    };
  }

  /**
   * @description
   * Mutation callback when add user is completed.
   *
   * @param {Object} createAdmin - Mutation result.
   */
  changePasswordCompleted = async ({ updateAdminUser }) => {
    const history = this.context;
    const { errors, token } = updateAdminUser;
    if (errors) {
      this.setState({ errors });
    } else {
      this.saveToken(token);
      history.push(DASHBOARD);
    }
  };

  /**
   * @description
   * Save token in localStorage after login.
   *
   * @param {Object} token - Token to save.
   */
  saveToken = token => {
    localStorage.setItem(AUTH_TOKEN, token);
  };

  /**
   * @description
   * Render ChangePassword component.
   */
  render() {
    const { errors } = this.state;
    return (
      <AuthContext.Consumer>
        {({ id }) => (
          <Mutation
            mutation={UPDATE_USER_MUTATION}
            onCompleted={this.changePasswordCompleted}
          >
            {(handleChangePassword, { loading }) => (
              <ChangePassword
                passwordUpdate={data => {
                  handleChangePassword({ variables: { id, ...data } });
                }}
                loading={loading}
                errors={errors}
                {...this.props}
              />
            )}
          </Mutation>
        )}
      </AuthContext.Consumer>
    );
  }
}

export default UserChangePasswordContainer;
